import agile_software_development from "./agile_software_development.yaml";
import agile_software_development_polska from "./agile_software_development_polska.yaml";
import agile_software_development_services from "./agile_software_development_services.yaml";
import agile_software_development_services_pl from "./agile_software_development_services_pl.yaml";
import ai_chatbot_development_services from "./ai_chatbot_development_services.yaml";
import ai_chatbot_development_services_pl from "./ai_chatbot_development_services_pl.yaml";
import ai_development_services from "./ai_development_services.yaml";
import animated_websites_services from "./animated_websites_services.yaml";
import animowane_strony_internetowe from "./animowane_strony_internetowe.yaml";
import aplikacja_bluetooth_na_androida from "./aplikacja_bluetooth_na_androida.yaml";
import aplikacja_webowa_vs_aplikacja_desktopowa from "./aplikacja_webowa_vs_aplikacja_desktopowa.yaml";
import aplikacja_webowa_vs_aplikacja_mobilna from "./aplikacja_webowa_vs_aplikacja_mobilna.yaml";
import aplikacje_ios from "./aplikacje_ios.yaml";
import aplikacje_medyczne_software_house from "./aplikacje_medyczne_software_house.yaml";
import aplikacje_mobilne_dla_biznesu from "./aplikacje_mobilne_dla_biznesu.yaml";
import application_maintenance_support from "./application_maintenance_support.yaml";
import application_scaling from "./application_scaling.yaml";
import arduino_development_services from "./arduino_development_services.yaml";
import arduino_development_services_pl from "./arduino_development_services_pl.yaml";
import automated_data_processing from "./automated_data_processing.yaml";
import automated_regression_testing from "./automated_regression_testing.yaml";
import automatyczne_przetwarzanie_danych from "./automatyczne_przetwarzanie_danych.yaml";
import automatyczne_testy_regresyjne from "./automatyczne_testy_regresyjne.yaml";
import baremetal_programming from "./baremetal_programming.yaml";
import bespoke_mvp_development_company from "./bespoke_mvp_development_company.yaml";
import bespoke_software from "./bespoke_software.yaml";
import bespoke_software_development_company from "./bespoke_software_development_company.yaml";
import bespoke_software_development_company_pl from "./bespoke_software_development_company_pl.yaml";
import best_programming_language_it from "./best_programming_language_it.yaml";
import bluetooth_application_for_android from "./bluetooth_application_for_android.yaml";
import body_leasing from "./body_leasing.yaml";
import body_leasing_polska from "./body_leasing_polska.yaml";
import business_intelligence_solutions from "./business_intelligence_solutions.yaml";
import chatbot_services from "./chatbot_services.yaml";
import cloud_adoption from "./cloud_adoption.yaml";
import cloud_application_development_services from "./cloud_application_development_services.yaml";
import cloud_migration_companies from "./cloud_migration_companies.yaml";
import cross_platform_mobile_development from "./cross_platform_mobile_development.yaml";
import cross_platform_mobile_development_pl from "./cross_platform_mobile_development_pl.yaml";
import cto_as_a_service from "./cto_as_a_service.yaml";
import cto_jako_usluga from "./cto_jako_usluga.yaml";
import custom_cms_solutions from "./custom_cms_solutions.yaml";
import custom_management_system from "./custom_management_system.yaml";
import custom_software_development_on_demand from "./custom_software_development_on_demand.yaml";
import custom_software_development_service from "./custom_software_development_service.yaml";
import custom_web_app_development_services from "./custom_web_app_development_services.yaml";
import custom_web_app_development_solutions from "./custom_web_app_development_solutions.yaml";
import data_center_migration_companies from "./data_center_migration_companies.yaml";
import data_engineering_services from "./data_engineering_services.yaml";
import dedicated_development_team from "./dedicated_development_team.yaml";
import dedicated_software_development_team from "./dedicated_software_development_team.yaml";
import devops_as_a_service from "./devops_as_a_service.yaml";
import devops_consulting_company from "./devops_consulting_company.yaml";
import devops_jako_usluga from "./devops_jako_usluga.yaml";
import dostawa_oprogramowania from "./dostawa_oprogramowania.yaml";
import eaa_accessibility_compliance from "./eaa_accessibility_compliance.yaml";
import eaa_dostepnosc_zgodnosc from "./eaa_dostepnosc_zgodnosc.yaml";
import ecommerce_website_costs from "./ecommerce_website_costs.yaml";
import edge_ai_i_widzenie_komputerowe from "./edge_ai_i_widzenie_komputerowe.yaml";
import electron_aplikacja_desktop from "./electron_aplikacja_desktop.yaml";
import electron_js from "./electron_js.yaml";
import embedded_development_services from "./embedded_development_services.yaml";
import embedded_software_development from "./embedded_software_development.yaml";
import embedded_software_engineering from "./embedded_software_engineering.yaml";
import embedded_software_outsourcing from "./embedded_software_outsourcing.yaml";
import embedded_software_staff_augmentation from "./embedded_software_staff_augmentation.yaml";
import end_to_end_it_solutions from "./end_to_end_it_solutions.yaml";
import energy_storage_systems_for_solar_power from "./energy_storage_systems_for_solar_power.yaml";
import enterprise_mobile_app_development from "./enterprise_mobile_app_development.yaml";
import firma_konsultingowa_devops from "./firma_konsultingowa_devops.yaml";
import firma_rozwoju_ai from "./firma_rozwoju_ai.yaml";
import firmy_migracji_centrow_danych from "./firmy_migracji_centrow_danych.yaml";
import firmy_migracji_chmurowej from "./firmy_migracji_chmurowej.yaml";
import fixed_price_vs_time_and_material from "./fixed_price_vs_time_and_material.yaml";
import flutter_aplikacje_na_mobile from "./flutter_aplikacje_na_mobile.yaml";
import flutter_app_development from "./flutter_app_development.yaml";
import flutter_development_services from "./flutter_development_services.yaml";
import flutter_development_services_pl from "./flutter_development_services_pl.yaml";
import generative_healthcare from "./generative_healthcare.yaml";
import generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej from "./generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej.yaml";
import hardware_design from "./hardware_design.yaml";
import hardware_development from "./hardware_development.yaml";
import hire_dedicated_development_team from "./hire_dedicated_development_team.yaml";
import hire_java_developers from "./hire_java_developers.yaml";
import hybrid_mobile_app_development from "./hybrid_mobile_app_development.yaml";
import hybrydowy_rozwoj_aplikacji_mobilnych from "./hybrydowy_rozwoj_aplikacji_mobilnych.yaml";
import integracja_i_programowanie from "./integracja_i_programowanie.yaml";
import integracja_i_testowanie_systemowe from "./integracja_i_testowanie_systemowe.yaml";
import integracje_systemow from "./integracje_systemow.yaml";
import integration_and_system_testing from "./integration_and_system_testing.yaml";
import internet_of_things_development from "./internet_of_things_development.yaml";
import internet_of_things_smart_cities from "./internet_of_things_smart_cities.yaml";
import internet_rzeczy_miasta_inteligentne from "./internet_rzeczy_miasta_inteligentne.yaml";
import inzynieria_oprogramowania_embedded from "./inzynieria_oprogramowania_embedded.yaml";
import ios_app_programming from "./ios_app_programming.yaml";
import ios_development_language from "./ios_development_language.yaml";
import ios_pwa from "./ios_pwa.yaml";
import iot_companies from "./iot_companies.yaml";
import iot_development_services from "./iot_development_services.yaml";
import iot_device_management from "./iot_device_management.yaml";
import iot_embedded_solutions from "./iot_embedded_solutions.yaml";
import iot_firmy from "./iot_firmy.yaml";
import iot_in_retail from "./iot_in_retail.yaml";
import iot_industry_4_0 from "./iot_industry_4_0.yaml";
import iot_mqtt from "./iot_mqtt.yaml";
import iot_mqtt_pl from "./iot_mqtt_pl.yaml";
import iot_product_development_company from "./iot_product_development_company.yaml";
import iot_przemysl_4_0 from "./iot_przemysl_4_0.yaml";
import iot_rozwiazania_embedded from "./iot_rozwiazania_embedded.yaml";
import iot_tworzenie_produktow from "./iot_tworzenie_produktow.yaml";
import iot_urzadzenia_ubieralne from "./iot_urzadzenia_ubieralne.yaml";
import iot_w_handlu from "./iot_w_handlu.yaml";
import iot_w_zarzadzaniu_urzadzeniami from "./iot_w_zarzadzaniu_urzadzeniami.yaml";
import iot_wearables_technology from "./iot_wearables_technology.yaml";
import it_system_testing from "./it_system_testing.yaml";
import javascript_backend_development from "./javascript_backend_development.yaml";
import javascript_backend_strony_internetowej from "./javascript_backend_strony_internetowej.yaml";
import konsultacje_machine_learning from "./konsultacje_machine_learning.yaml";
import koszty_strony_ecommerce from "./koszty_strony_ecommerce.yaml";
import leagacy_application_modernization from "./leagacy_application_modernization.yaml";
import legacy_it_systems from "./legacy_it_systems.yaml";
import llm_product_development_llm_agency_llm_finetuning from "./llm_product_development_llm_agency_llm_finetuning.yaml";
import machine_learning_companies from "./machine_learning_companies.yaml";
import machine_learning_predictive_analytics from "./machine_learning_predictive_analytics.yaml";
import machine_learning_supply_chain_technology from "./machine_learning_supply_chain_technology.yaml";
import machine_vision_vs_computer_vision from "./machine_vision_vs_computer_vision.yaml";
import medical_applications from "./medical_applications.yaml";
import microcontroller_cpu from "./microcontroller_cpu.yaml";
import microcontroller_cpu_polska from "./microcontroller_cpu_polska.yaml";
import microservices_vs_monolithic from "./microservices_vs_monolithic.yaml";
import migracja_oprogramowania from "./migracja_oprogramowania.yaml";
import mikroserwisy_vs_monolit from "./mikroserwisy_vs_monolit.yaml";
import mobile_development_services from "./mobile_development_services.yaml";
import modernizacja_aplikacji_legacy from "./modernizacja_aplikacji_legacy.yaml";
import mvp_development from "./mvp_development.yaml";
import mvp_development_pl from "./mvp_development_pl.yaml";
import mvp_i_oprogramowanie_dedykowane from "./mvp_i_oprogramowanie_dedykowane.yaml";
import mvp_rozwoj_oprogramowania from "./mvp_rozwoj_oprogramowania.yaml";
import mvp_software_development from "./mvp_software_development.yaml";
import najlepszy_jezyk_programowania_dla_iot from "./najlepszy_jezyk_programowania_dla_iot.yaml";
import nb_iot from "./nb_iot.yaml";
import nb_iot_polska from "./nb_iot_polska.yaml";
import nearshoring_it from "./nearshoring_it.yaml";
import nearshoring_it_polska from "./nearshoring_it_polska.yaml";
import nextjs_wordpress_services from "./nextjs_wordpress_services.yaml";
import nextjs_wordpress_uslugi from "./nextjs_wordpress_uslugi.yaml";
import niestandardowe_rozwiazania_cms from "./niestandardowe_rozwiazania_cms.yaml";
import niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych from "./niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych.yaml";
import niestandardowe_uslugi_tworzenia_aplikacji_www from "./niestandardowe_uslugi_tworzenia_aplikacji_www.yaml";
import niestandardowy_system_zarzadzania from "./niestandardowy_system_zarzadzania.yaml";
import node_js_agencje from "./node_js_agencje.yaml";
import node_js_development_companies from "./node_js_development_companies.yaml";
import node_js_development_company from "./node_js_development_company.yaml";
import node_js_firmy_programistyczne from "./node_js_firmy_programistyczne.yaml";
import offshore_software_development from "./offshore_software_development.yaml";
import okreslona_cena_vs_czas_i_materialy from "./okreslona_cena_vs_czas_i_materialy.yaml";
import on_demand_services from "./on_demand_services.yaml";
import oprogramowanie_business_intelligence from "./oprogramowanie_business_intelligence.yaml";
import oprogramowanie_dla_branzy_turystycznej from "./oprogramowanie_dla_branzy_turystycznej.yaml";
import oprogramowanie_dla_nieruchomosci from "./oprogramowanie_dla_nieruchomosci.yaml";
import oprogramowanie_prototypowanie_polska from "./oprogramowanie_prototypowanie_polska.yaml";
import oprogramowanie_szyte_na_miare from "./oprogramowanie_szyte_na_miare.yaml";
import outsource_python_development from "./outsource_python_development.yaml";
import outsourcing_inzynierii_programowania from "./outsourcing_inzynierii_programowania.yaml";
import outsourcing_programowania_python from "./outsourcing_programowania_python.yaml";
import outsourcing_projektow_it from "./outsourcing_projektow_it.yaml";
import outsourcing_rozwoju_oprogramowania from "./outsourcing_rozwoju_oprogramowania.yaml";
import outsourcing_software_projects from "./outsourcing_software_projects.yaml";
import product_development_services from "./product_development_services.yaml";
import product_discovery_workshop from "./product_discovery_workshop.yaml";
import product_management_vs_product_owner from "./product_management_vs_product_owner.yaml";
import programowanie_baremetal from "./programowanie_baremetal.yaml";
import programowanie_offshore from "./programowanie_offshore.yaml";
import progressive_web_app_development_services from "./progressive_web_app_development_services.yaml";
import projektowanie_sprzetu from "./projektowanie_sprzetu.yaml";
import proof_of_concept from "./proof_of_concept.yaml";
import proof_of_concept_pl from "./proof_of_concept_pl.yaml";
import proof_of_concept_vs_prototype from "./proof_of_concept_vs_prototype.yaml";
import prototypowanie_i_testy_rozwoju from "./prototypowanie_i_testy_rozwoju.yaml";
import pwa_development_services from "./pwa_development_services.yaml";
import react_development_services from "./react_development_services.yaml";
import reactjs_software_house from "./reactjs_software_house.yaml";
import reactjs_web_development_company from "./reactjs_web_development_company.yaml";
import real_estate_software_companies from "./real_estate_software_companies.yaml";
import rozszerzenie_zespolu_it from "./rozszerzenie_zespolu_it.yaml";
import rozwiazania_end_to_end from "./rozwiazania_end_to_end.yaml";
import rozwoj_aplikacji_ios from "./rozwoj_aplikacji_ios.yaml";
import rozwoj_aplikacji_mobilnych from "./rozwoj_aplikacji_mobilnych.yaml";
import rozwoj_aplikacji_react from "./rozwoj_aplikacji_react.yaml";
import rozwoj_internetu_rzeczy from "./rozwoj_internetu_rzeczy.yaml";
import rozwoj_oprogramowania_embedded from "./rozwoj_oprogramowania_embedded.yaml";
import rozwoj_produktu_llm_agencja_llm from "./rozwoj_produktu_llm_agencja_llm.yaml";
import rozwoj_progresywnych_aplikacji_internetowych from "./rozwoj_progresywnych_aplikacji_internetowych.yaml";
import rozwoj_sprzetu from "./rozwoj_sprzetu.yaml";
import rozwoj_systemow_wbudowanych from "./rozwoj_systemow_wbudowanych.yaml";
import rtos_development from "./rtos_development.yaml";
import rtos_development_pl from "./rtos_development_pl.yaml";
import saas_chmurowe_rozwiazania from "./saas_chmurowe_rozwiazania.yaml";
import saas_chmurowe_rozwiązania from "./saas_chmurowe_rozwiązania.yaml";
import saas_cloud_solutions from "./saas_cloud_solutions.yaml";
import skalowanie_aplikacji from "./skalowanie_aplikacji.yaml";
import sla_driven_software_development from "./sla_driven_software_development.yaml";
import sla_i_uslugi_zarzadzane from "./sla_i_uslugi_zarzadzane.yaml";
import software_delivery from "./software_delivery.yaml";
import software_development_companies from "./software_development_companies.yaml";
import software_development_outsourcing from "./software_development_outsourcing.yaml";
import software_developmentowe_firmy from "./software_developmentowe_firmy.yaml";
import software_engineering_outsourcing from "./software_engineering_outsourcing.yaml";
import software_house_landing from "./software_house_landing.yaml";
import software_house_landing_pl from "./software_house_landing_pl.yaml";
import software_integration_service from "./software_integration_service.yaml";
import software_maintenance from "./software_maintenance.yaml";
import software_migration from "./software_migration.yaml";
import software_prototyping from "./software_prototyping.yaml";
import specjalistyczne_uslugi_inzynierii_oprogramowania from "./specjalistyczne_uslugi_inzynierii_oprogramowania.yaml";
import sportowe_aplikacje from "./sportowe_aplikacje.yaml";
import staff_augmentation_services from "./staff_augmentation_services.yaml";
import staff_augmentation_services_pl from "./staff_augmentation_services_pl.yaml";
import staff_augmentation_vs_managed_services from "./staff_augmentation_vs_managed_services.yaml";
import sw_engineering_services from "./sw_engineering_services.yaml";
import system_to_system_integration from "./system_to_system_integration.yaml";
import systemy_it_legacy from "./systemy_it_legacy.yaml";
import systemy_magazynowania_energii_solarnej from "./systemy_magazynowania_energii_solarnej.yaml";
import team_extension_it from "./team_extension_it.yaml";
import testowanie_oprogramowania_polska from "./testowanie_oprogramowania_polska.yaml";
import testowanie_systemow_it from "./testowanie_systemow_it.yaml";
import travel_software_development from "./travel_software_development.yaml";
import tworzenie_aplikacji_pwa from "./tworzenie_aplikacji_pwa.yaml";
import tworzenie_pwa_na_ios from "./tworzenie_pwa_na_ios.yaml";
import uczenie_maszynowe_analityka_predykcyjna from "./uczenie_maszynowe_analityka_predykcyjna.yaml";
import uczenie_maszynowe_technologia_lancuch_dostaw from "./uczenie_maszynowe_technologia_lancuch_dostaw.yaml";
import usluga_tworzenia_oprogramowania_na_zamowienie from "./usluga_tworzenia_oprogramowania_na_zamowienie.yaml";
import uslugi_chatbot from "./uslugi_chatbot.yaml";
import uslugi_inzynierii_danych from "./uslugi_inzynierii_danych.yaml";
import uslugi_na_zawolanie from "./uslugi_na_zawolanie.yaml";
import uslugi_rozwoju_aplikacji_w_chmurze from "./uslugi_rozwoju_aplikacji_w_chmurze.yaml";
import uslugi_rozwoju_iot from "./uslugi_rozwoju_iot.yaml";
import uslugi_rozwoju_produktow from "./uslugi_rozwoju_produktow.yaml";
import uslugi_tworzenia_oprogramowania_na_zamowienie from "./uslugi_tworzenia_oprogramowania_na_zamowienie.yaml";
import utrzymanie_i_wsparcie_aplikacji from "./utrzymanie_i_wsparcie_aplikacji.yaml";
import utrzymanie_oprogramowania from "./utrzymanie_oprogramowania.yaml";
import ux_ui_design_services from "./ux_ui_design_services.yaml";
import ux_ui_design_uslugi from "./ux_ui_design_uslugi.yaml";
import uzupelnienie_personelu_vs_uslugi_zarzadzane from "./uzupelnienie_personelu_vs_uslugi_zarzadzane.yaml";
import warsztaty_product_discovery from "./warsztaty_product_discovery.yaml";
import wdrozenie_chmury from "./wdrozenie_chmury.yaml";
import wearable_apps from "./wearable_apps.yaml";
import web_app_vs_desktop_app from "./web_app_vs_desktop_app.yaml";
import web_app_vs_mobile_app from "./web_app_vs_mobile_app.yaml";
import webapp_development_services from "./webapp_development_services.yaml";
import webapp_development_services_pl from "./webapp_development_services_pl.yaml";
import what_is_quality_assurance_testing from "./what_is_quality_assurance_testing.yaml";
import white_label_aplikacje from "./white_label_aplikacje.yaml";
import white_label_apps from "./white_label_apps.yaml";
import zarzadzanie_produktami_wlasciciel_produktu from "./zarzadzanie_produktami_wlasciciel_produktu.yaml";
import zatrudnij_programistow_java from "./zatrudnij_programistow_java.yaml";
import zatrudnij_wyspecjalizowany_zespol_programistow from "./zatrudnij_wyspecjalizowany_zespol_programistow.yaml";
import zatrudnij_zespol_deweloperow from "./zatrudnij_zespol_deweloperow.yaml";
import zespol_dedykowany_do_rozwoju_oprogramowania from "./zespol_dedykowany_do_rozwoju_oprogramowania.yaml";

export const services = {
  en: {
    agile_software_development_services,
    agile_software_development,
    ai_chatbot_development_services,
    ai_development_services,
    animated_websites_services,
    application_maintenance_support,
    application_scaling,
    arduino_development_services,
    automated_data_processing,
    automated_regression_testing,
    baremetal_programming,
    bespoke_mvp_development_company,
    bespoke_software_development_company,
    bespoke_software,
    best_programming_language_it,
    bluetooth_application_for_android,
    body_leasing,
    business_intelligence_solutions,
    chatbot_services,
    cloud_adoption,
    cloud_application_development_services,
    cloud_migration_companies,
    cross_platform_mobile_development,
    cto_as_a_service,
    custom_cms_solutions,
    custom_management_system,
    custom_software_development_on_demand,
    custom_software_development_service,
    custom_web_app_development_services,
    custom_web_app_development_solutions,
    data_center_migration_companies,
    data_engineering_services,
    dedicated_development_team,
    dedicated_software_development_team,
    devops_as_a_service,
    devops_consulting_company,
    eaa_accessibility_compliance,
    ecommerce_website_costs,
    electron_js,
    embedded_development_services,
    embedded_software_development,
    embedded_software_engineering,
    embedded_software_outsourcing,
    embedded_software_staff_augmentation,
    end_to_end_it_solutions,
    energy_storage_systems_for_solar_power,
    enterprise_mobile_app_development,
    fixed_price_vs_time_and_material,
    flutter_app_development,
    flutter_development_services,
    generative_healthcare,
    hardware_design,
    hardware_development,
    hire_dedicated_development_team,
    hire_java_developers,
    hybrid_mobile_app_development,
    integration_and_system_testing,
    internet_of_things_development,
    internet_of_things_smart_cities,
    ios_app_programming,
    ios_development_language,
    ios_pwa,
    iot_companies,
    iot_development_services,
    iot_device_management,
    iot_embedded_solutions,
    iot_in_retail,
    iot_industry_4_0,
    iot_mqtt,
    iot_product_development_company,
    iot_wearables_technology,
    it_system_testing,
    javascript_backend_development,
    leagacy_application_modernization,
    legacy_it_systems,
    llm_product_development_llm_agency_llm_finetuning,
    machine_learning_companies,
    machine_learning_predictive_analytics,
    machine_learning_supply_chain_technology,
    machine_vision_vs_computer_vision,
    medical_applications,
    microcontroller_cpu,
    microservices_vs_monolithic,
    mobile_development_services,
    mvp_development,
    mvp_software_development,
    nb_iot,
    nearshoring_it,
    nextjs_wordpress_services,
    node_js_development_companies,
    node_js_development_company,
    offshore_software_development,
    on_demand_services,
    outsource_python_development,
    outsourcing_software_projects,
    product_development_services,
    product_discovery_workshop,
    product_management_vs_product_owner,
    progressive_web_app_development_services,
    proof_of_concept_vs_prototype,
    proof_of_concept,
    pwa_development_services,
    react_development_services,
    reactjs_web_development_company,
    real_estate_software_companies,
    rtos_development,
    saas_cloud_solutions,
    sla_driven_software_development,
    software_delivery,
    software_development_companies,
    software_development_outsourcing,
    software_engineering_outsourcing,
    software_house_landing,
    software_integration_service,
    software_maintenance,
    software_migration,
    software_prototyping,
    staff_augmentation_services,
    staff_augmentation_vs_managed_services,
    sw_engineering_services,
    system_to_system_integration,
    team_extension_it,
    travel_software_development,
    ux_ui_design_services,
    wearable_apps,
    web_app_vs_desktop_app,
    web_app_vs_mobile_app,
    webapp_development_services,
    what_is_quality_assurance_testing,
    white_label_apps,
  },
  pl: {
    agile_software_development_polska,
    agile_software_development_services_pl,
    ai_chatbot_development_services_pl,
    animowane_strony_internetowe,
    aplikacja_bluetooth_na_androida,
    aplikacja_webowa_vs_aplikacja_desktopowa,
    aplikacja_webowa_vs_aplikacja_mobilna,
    aplikacje_ios,
    aplikacje_medyczne_software_house,
    aplikacje_mobilne_dla_biznesu,
    arduino_development_services_pl,
    automatyczne_przetwarzanie_danych,
    automatyczne_testy_regresyjne,
    bespoke_software_development_company_pl,
    body_leasing_polska,
    cross_platform_mobile_development_pl,
    cto_jako_usluga,
    devops_jako_usluga,
    dostawa_oprogramowania,
    eaa_dostepnosc_zgodnosc,
    edge_ai_i_widzenie_komputerowe,
    electron_aplikacja_desktop,
    firma_konsultingowa_devops,
    firma_rozwoju_ai,
    firmy_migracji_centrow_danych,
    firmy_migracji_chmurowej,
    flutter_aplikacje_na_mobile,
    flutter_development_services_pl,
    generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej,
    hybrydowy_rozwoj_aplikacji_mobilnych,
    integracja_i_programowanie,
    integracja_i_testowanie_systemowe,
    integracje_systemow,
    internet_rzeczy_miasta_inteligentne,
    inzynieria_oprogramowania_embedded,
    iot_firmy,
    iot_mqtt_pl,
    iot_przemysl_4_0,
    iot_rozwiazania_embedded,
    iot_tworzenie_produktow,
    iot_urzadzenia_ubieralne,
    iot_w_handlu,
    iot_w_zarzadzaniu_urzadzeniami,
    javascript_backend_strony_internetowej,
    konsultacje_machine_learning,
    koszty_strony_ecommerce,
    microcontroller_cpu_polska,
    migracja_oprogramowania,
    mikroserwisy_vs_monolit,
    modernizacja_aplikacji_legacy,
    mvp_development_pl,
    mvp_i_oprogramowanie_dedykowane,
    mvp_rozwoj_oprogramowania,
    najlepszy_jezyk_programowania_dla_iot,
    nb_iot_polska,
    nearshoring_it_polska,
    nextjs_wordpress_uslugi,
    niestandardowe_rozwiazania_cms,
    niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych,
    niestandardowe_uslugi_tworzenia_aplikacji_www,
    niestandardowy_system_zarzadzania,
    node_js_agencje,
    node_js_firmy_programistyczne,
    okreslona_cena_vs_czas_i_materialy,
    oprogramowanie_business_intelligence,
    oprogramowanie_dla_branzy_turystycznej,
    oprogramowanie_dla_nieruchomosci,
    oprogramowanie_prototypowanie_polska,
    oprogramowanie_szyte_na_miare,
    outsourcing_inzynierii_programowania,
    outsourcing_programowania_python,
    outsourcing_projektow_it,
    outsourcing_rozwoju_oprogramowania,
    programowanie_baremetal,
    programowanie_offshore,
    projektowanie_sprzetu,
    proof_of_concept_pl,
    prototypowanie_i_testy_rozwoju,
    reactjs_software_house,
    rozszerzenie_zespolu_it,
    rozwiazania_end_to_end,
    rozwoj_aplikacji_ios,
    rozwoj_aplikacji_mobilnych,
    rozwoj_aplikacji_react,
    rozwoj_internetu_rzeczy,
    rozwoj_oprogramowania_embedded,
    rozwoj_produktu_llm_agencja_llm,
    rozwoj_progresywnych_aplikacji_internetowych,
    rozwoj_sprzetu,
    rozwoj_systemow_wbudowanych,
    rtos_development_pl,
    saas_chmurowe_rozwiazania,
    saas_chmurowe_rozwiązania,
    skalowanie_aplikacji,
    sla_i_uslugi_zarzadzane,
    software_developmentowe_firmy,
    software_house_landing_pl,
    software_migration,
    specjalistyczne_uslugi_inzynierii_oprogramowania,
    sportowe_aplikacje,
    staff_augmentation_services_pl,
    systemy_it_legacy,
    systemy_magazynowania_energii_solarnej,
    testowanie_oprogramowania_polska,
    testowanie_systemow_it,
    tworzenie_aplikacji_pwa,
    tworzenie_pwa_na_ios,
    uczenie_maszynowe_analityka_predykcyjna,
    uczenie_maszynowe_technologia_lancuch_dostaw,
    usluga_tworzenia_oprogramowania_na_zamowienie,
    uslugi_chatbot,
    uslugi_inzynierii_danych,
    uslugi_na_zawolanie,
    uslugi_rozwoju_aplikacji_w_chmurze,
    uslugi_rozwoju_iot,
    uslugi_rozwoju_produktow,
    uslugi_tworzenia_oprogramowania_na_zamowienie,
    utrzymanie_i_wsparcie_aplikacji,
    utrzymanie_oprogramowania,
    ux_ui_design_uslugi,
    uzupelnienie_personelu_vs_uslugi_zarzadzane,
    warsztaty_product_discovery,
    wdrozenie_chmury,
    webapp_development_services_pl,
    white_label_aplikacje,
    zarzadzanie_produktami_wlasciciel_produktu,
    zatrudnij_programistow_java,
    zatrudnij_wyspecjalizowany_zespol_programistow,
    zatrudnij_zespol_deweloperow,
    zespol_dedykowany_do_rozwoju_oprogramowania,
  },
};

export const languageServiceMap: Record<string, string> = {
  react_development_services: "rozwoj_aplikacji_react",
  embedded_development_services: "rozwoj_systemow_wbudowanych",
  mobile_development_services: "rozwoj_aplikacji_mobilnych",
  arduino_development_services: "arduino_development_services_pl",
  rtos_development: "rtos_development_pl",
  mvp_development: "mvp_development_pl",
  agile_software_development_services: "agile_software_development_services_pl",
  flutter_development_services: "flutter_development_services_pl",
  proof_of_concept: "proof_of_concept_pl",
  cross_platform_mobile_development: "cross_platform_mobile_development_pl",
  software_house_landing: "software_house_landing_pl",
  staff_augmentation_services: "staff_augmentation_services_pl",
  pwa_development_services: "tworzenie_aplikacji_pwa",
  animated_websites_services: "animowane_strony_internetowe",
  ux_ui_design_services: "ux_ui_design_uslugi",
  hardware_design: "projektowanie_sprzetu",
  application_maintenance_support: "utrzymanie_i_wsparcie_aplikacji",
  eaa_accessibility_compliance: "eaa_dostepnosc_zgodnosc",
  software_maintenance: "utrzymianie_oprogramownaia",
  hire_dedicated_development_team: "zatrudnij_zespol_deweloperow",
  data_engineering_zgodnosc: "uslugi_inzynierii_danych",
  business_intelligence_solutions: "oprogramowanie_business_intelligence",
  iot_development_services: "uslugi_rozwoju_iot",
  ai_chatbot_development_services: "ai_chatbot_development_services_pl",
  nextjs_wordpress_services: "nextjs_wordpress_uslugi",
  webapp_development_services: "webapp_development_services_pl",
  devops_consulting_company: "firma_konsultingowa_devops",
  javascript_frontend_backend: "javascript_backend_strony_internetowej",
  devops_as_a_service: "devops_jako_usluga",
  saas_cloud_solutions: "saas_chmurowe_rozwiazania",
  machine_learning_predictive_analytics:
    "uczenie_maszynowe_analityka_predykcyjna",
  nb_iot: "nb_iot_polska",
  microservices_vs_monolithic: "mikroserwisy_vs_monolit",
  internet_of_things_smart_cities: "internet_rzeczy_miasta_inteligentne",
  internet_of_things_development: "rozwoj_internetu_rzeczy",
  sla_driven_software_development: "sla_i_uslugi_zarzadzane",
  iot_industry_4_0: "iot_przemysl_4_0",
  outsource_python_development: "outsourcing_programowania_python",
  energy_storage_systems_for_solar_power:
    "systemy_magazynowania_energii_solarnej",
  iot_device_management: "iot_w_zarzadzaniu_urzadzeniami",
  javascript_backend_development: "javascript_backend_strony_internetowej",
  travel_software_development: "oprogramowanie_dla_branzy_turystycznej",
  iot_wearables_technology: "iot_urzadzenia_ubieralne",
  software_migration: "migracja_oprogramowania",
  data_center_migration_companies: "firmy_migracji_centrow_danych",
  software_prototyping: "oprogramowanie_prototypowanie_polska",
  ios_development_language: "rozwoj_aplikacji_ios",
  best_programming_language_it: "najlepszy_jezyk_programowania_dla_iot",
  what_is_quality_assurance_testing: "testowanie_oprogramowania_polska",
  it_system_testing: "testowanie_systemow_it",
  software_delivery: "dostawa_oprogramowania",
  medical_applications: "aplikacje_medyczne_software_house",
  generative_healthcare:
    "generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej",
  machine_learning_supply_chain_technology:
    "uczenie_maszynowe_technologia_lancuch_dostaw",
  nearshoring_it: "nearshoring_it_polska",
  fixed_price_vs_time_and_material: "okreslona_cena_vs_czas_i_materialy",
  leagacy_application_modernization: "modernizacja_aplikacji_legacy",
  legacy_it_systems: "systemy_it_legacy",
  cto_as_a_service: "cto_as_a_service",
  application_scaling: "skalowanie_aplikacji",
  embedded_software_engineering: "embedded_software_engineering",
  reactjs_web_development_company: "reactjs_software_house",
  electron_js: "electron_aplikacja_desktop",
  node_js_development_companies: "node_js_agencje",
  flutter_app_development: "flutter_aplikacje_na_mobile",
  hire_java_developers: "zatrudnij_programistow_java",
  machine_learning_companies: "konsultacje_machine_learning",
  custom_software_development_on_demand:
    "uslugi_tworzenia_oprogramowania_na_zamowienie",
  embedded_software_development: "embedded_software_development",
  software_development_companies: "software_developmentowe_firmy",
  hardware_development: "rozwoj_sprzetu",
  chatbot_services: "uslugi_chatbot",
  ios_pwa: "tworzenie_pwa_na_ios",
  ios_app_programming: "aplikacje_ios",
  bluetooth_application_for_android: "aplikacja_bluetooth_na_androida",
  software_engineering_outsourcing: "outsourcing_inzynierii_oprogramowania",
  sw_engineering_services: "specjalistyczne_uslugi_inzynierii_oprogramowania",
  custom_web_app_development_services:
    "niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych",
  progressive_web_app_development_services:
    "rozwoj_progresywnych_aplikacji_internetowych",
  web_app_vs_desktop_app: "aplikacja_webowa_vs_aplikacja_desktopowa",
  web_app_vs_mobile_app: "aplikacja_webowa_vs_aplikacja_mobilna",
  agile_software_development: "agile_software_development_polska",
  outsourcing_software_projects: "outsourcing_projektów_it",
  software_development_outsourcing: "outsourcing_rozwoju_oprogramowania",
  offshore_software_development: "programowanie_offshore",
  iot_embedded_solutions: "iot_rozwiazania_embedded",
  iot_in_retail: "iot_w_handlu",
  product_development_services: "uslugi_rozwoju_produktow",
  iot_product_development_company: "iot_tworzenie_produktow",
  enterprise_mobile_app_development: "aplikacje_mobilne_dla_biznesu",
  iot_mqtt: "iot_mqtt_pl",
  bespoke_mvp_development_company: "tworzenie_i_oprogramowanie_dedykowane",
  bespoke_software_development_company:
    "bespoke_software_development_company_pl",
  node_js_development_company: "node_js_firmy_programistyczne",
  baremetal_programming: "programowanie_baremetal",
  custom_cms_solutions: "niestandardowe_rozwiazania_cms",
  custom_software_development_service:
    "usluga_tworzenia_oprogramowania_na_zamowienie",
  white_label_apps: "white_label_aplikacje",
  bespoke_software: "oprogramowanie_na_miar3",
  cloud_adoption: "wdrozenie_chmury",
  cloud_application_development_services: "uslugi_rozwoju_aplikacji_w_chmurze",
  cloud_migration_companies: "firmy_migracji_chmurowej",
  dedicated_development_team: "zatrudnij_wyspecjalizowany_zespol_programistow",
  dedicated_software_development_team:
    "zespol_dedykowany_do_rozwoju_oprogramowania",
  integration_and_system_testing: "integracje_i_testowanie_systemowe",
  software_integration_service: "integracja_i_programowanie",
  system_to_system_integration: "integracje_systemow",
  embedded_software_outsourcing: "rozwoj_systemow_wbudowanych",
  embedded_software_staff_augmentation: "rozwoj_systemow_wbudowanych",
  product_management_vs_product_owner:
    "zarzadzanie_produktami_wlasciciel_produktu",
  custom_management_system: "niestandardowy_system_zarzadzania",
  on_demand_services: "uslugi_na_zawolanie",
  body_leasing: "body_leasing_polska",
  ai_development_services: "firma_rozwoju_ai",
  product_discovery_workshop: "warsztaty_product_discovery",
  machine_vision_vs_computer_vision: "edge_ai_i_widzenie_komputerowe",
  staff_augmentation_vs_managed_services:
    "uzupelnienie_personelu_vs_uslugi_zarzadzane",
  mvp_software_development: "mvp_rozwoj_oprogramowania",
  hybrid_mobile_app_development: "hybrydowy_rozwoj_aplikacji_mobilnych",
  automated_data_processing: "automatyczne_przetwarzanie_danych",
  wearable_apps: "wearable_apps",
  llm_product_development_llm_agency_llm_finetuning:
    "rozwoj_produktu_llm_agencja_llm",
  proof_of_concept_vs_prototype: "prototypowanie_i_testy_rozwoju",
  ecommerce_website_costs: "koszty_strony_ecommerce",
  end_to_end_it_solutions: "rozwiazania_end_to_end",
  team_extension_it: "rozszerzenie_zespolu_it",
  real_estate_software_companies: "oprogramowanie_dla_nieruchomosci",
  automated_regression_testing: "automatyczne_testy_regresyjne",

  rozwoj_aplikacji_react: "react_development_services",
  rozwoj_systemow_wbudowanych: "embedded_development_services",
  rozwoj_aplikacji_mobilnych: "mobile_development_services",
  arduino_development_services_pl: "arduino_development_services",
  rtos_development_pl: "rtos_development",
  mvp_development_pl: "mvp_development",
  agile_software_development_services_pl: "agile_software_development_services",
  flutter_development_services_pl: "flutter_development_services",
  cross_platform_mobile_development_pl: "cross_platform_mobile_development",
  software_house_landing_pl: "software_house_landing",
  staff_augmentation_services_pl: "staff_augmentation_services",
  tworzenie_aplikacji_pwa: "pwa_development_services",
  animowane_strony_internetowe: "animated_websites_services",
  ux_ui_design_uslugi: "ux_ui_design_services",
  projektowanie_sprzetu: "hardware_design",
  utrzymanie_i_wsparcie_aplikacji: "application_maintenance_support",
  eaa_dostepnosc_zgodnosc: "eaa_accessibility_compliance",
  utrzymianie_oprogramownaia: "software_maintenance",
  zatrudnij_zespol_deweloperow: "hire_dedicated_development_team",
  uslugi_inzynierii_danych: "data_engineering_zgodnosc",
  oprogramowanie_business_intelligence: "business_intelligence_solutions",
  uslugi_rozwoju_iot: "iot_development_services",
  ai_chatbot_development_services_pl: "ai_chatbot_development_services",
  nextjs_wordpress_uslugi: "nextjs_wordpress_services",
  webapp_development_services_pl: "webapp_development_services",
  firma_konsultingowa_devops: "devops_consulting_company",
  javascript_backend_strony_internetowej: "javascript_frontend_backend",
  devops_jako_usluga: "devops_as_a_service",
  saas_chmurowe_rozwiazania: "saas_cloud_solutions",
  nb_iot_polska: "nb_iot",
  internet_rzeczy_miasta_inteligentne: "internet_of_things_smart_cities",
  rozwoj_internetu_rzeczy: "internet_of_things_development",
  sla_i_uslugi_zarzadzane: "sla_driven_software_development",
  iot_przemysl_4_0: "iot_industry_4_0",
  outsourcing_programowania_python: "outsource_python_development",
  systemy_magazynowania_energii_solarnej:
    "energy_storage_systems_for_solar_power",
  iot_w_zarzadzaniu_urzadzeniami: "iot_device_management",
  uczenie_maszynowe_analityka_predykcyjna:
    "machine_learning_predictive_analytics",
  saas_chmurowe_rozwiązania: "saas_cloud_solutions",
  mikroserwisy_vs_monolit: "microservices_vs_monolithic",
  zarzadzanie_produktami_wlasciciel_produktu:
    "product_management_vs_product_owner",
  niestandardowy_system_zarzadzania: "custom_management_system",
  uslugi_na_zawolanie: "on_demand_services",
  body_leasing_polska: "body_leasing",
  firma_rozwoju_ai: "ai_development_services",
  edge_ai_i_widzenie_komputerowe: "machine_vision_vs_computer_vision",
  wwarsztaty_product_discovery: "product_discovery_workshop",
  uzupelnienie_personelu_vs_uslugi_zarzadzane:
    "staff_augmentation_vs_managed_services",
  mvp_rozwoj_oprogramowania: "mvp_software_development",
  hybrydowy_rozwoj_aplikacji_mobilnych: "hybrid_mobile_app_development",
  automatyczne_przetwarzanie_danych: "automated_data_processing",
  sportowe_aplikacje: "sportowe_aplikacje",
  rozwoj_produktu_llm_agencja_llm:
    "llm_product_development_llm_agency_llm_finetuning",
  prototypowanie_i_testy_rozwoju: "proof_of_concept_vs_prototype",
  koszty_strony_ecommerce: "ecommerce_website_costs",
  rozwiazania_end_to_end: "end_to_end_it_solutions",
  rozszerzenie_zespolu_it: "team_extension_it",
  oprogramowanie_dla_nieruchomosci: "real_estate_software_companies",
  automatyczne_testy_regresyjne: "automated_regression_testing",
  oprogramowanie_dla_branzy_turystycznej: "travel_software_development",
  iot_urzadzenia_ubieralne: "iot_wearables_technology",
  firmy_migracji_centrow_danych: "data_center_migration_companies",
  oprogramowanie_prototypowanie_polska: "software_prototyping",
  migracja_oprogramowania: "software_migration",
  rozwoj_aplikacji_ios: "ios_development_language",
  najlepszy_jezyk_programowania_dla_iot: "best_programming_language_it",
  testowanie_oprogramowania_polska: "what_is_quality_assurance_testing",
  testowanie_systemow_it: "it_system_testing",
  dostawa_oprogramowania: "software_delivery",
  aplikacje_medyczne_software_house: "medical_applications",
  generatywna_sztuczna_inteligencja_w_opiece_zdrowotnej:
    "generative_healthcare",
  uczenie_maszynowe_technologia_lancuch_dostaw:
    "machine_learning_supply_chain_technology",
  nearshoring_it_polska: "nearshoring_it",
  okreslona_cena_vs_czas_i_materialy: "fixed_price_vs_time_and_material",
  modernizacja_aplikacji_legacy: "leagacy_application_modernization",
  systemy_it_legacy: "legacy_it_systems",
  cto_jako_usluga: "cto_as_a_service",
  skalowanie_aplikacji: "application_scaling",
  inzynieria_oprogramowania_embedded: "inzynieria_oprogramowania_embedded",
  reactjs_software_house: "reactjs_web_development_company",
  electron_aplikacja_desktop: "electron_js",
  node_js_agencje: "node_js_development_companies",
  flutter_aplikacje_na_mobile: "flutter_app_development",
  zatrudnij_programistow_java: "hire_java_developers",
  konsultacje_machine_learning: "machine_learning_companies",
  uslugi_tworzenia_oprogramowania_na_zamowienie:
    "custom_software_development_on_demand",
  rozwoj_oprogramowania_embedded: "embedded_software_development",
  software_developmentowe_firmy: "software_development_companies",
  rozwoj_sprzetu: "hardware_development",
  uslugi_chatbot: "chatbot_services",
  tworzenie_pwa_na_ios: "ios_pwa",
  aplikacje_ios: "ios_app_programming",
  aplikacja_bluetooth_na_androida: "bluetooth_application_for_android",
  outsourcing_inzynierii_oprogramowania: "software_engineering_outsourcing",
  specjalistyczne_uslugi_inzynierii_oprogramowania: "sw_engineering_services",
  niestandardowe_uslugi_i_tworzenie_aplikacji_internetowych:
    "custom_web_app_development_services",
  rozwoj_progresywnych_aplikacji_internetowych:
    "progressive_web_app_development_services",
  aplikacja_webowa_vs_aplikacja_desktopowa: "web_app_vs_desktop_app",
  aplikacja_webowa_vs_aplikacja_mobilna: "web_app_vs_mobile_app",
  agile_software_development_polska: "agile_software_development",
  outsourcing_projektow_it: "outsourcing_software_projects",
  outsourcing_rozwoju_oprogramowania: "software_development_outsourcing",
  programowanie_offshore: "offshore_software_development",
  iot_rozwiazania_embedded: "iot_embedded_solutions",
  iot_w_handlu: "iot_in_retail",
  uslugi_rozwoju_produktow: "product_development_services",
  iot_tworzenie_produktow: "iot_product_development_company",
  aplikacje_mobilne_dla_biznesu: "enterprise_mobile_app_development",
  iot_mqtt_pl: "iot_mqtt",
  tworzenie_i_oprogramowanie_dedykowane: "bespoke_mvp_development_company",
  bespoke_software_development_company_pl:
    "bespoke_software_development_company",
  node_js_firmy_programistyczne: "node_js_development_company",
  programowanie_baremetal: "baremetal_programming",
  niestandardowe_uslugi_tworzenia_aplikacji_www:
    "custom_web_app_development_services",
  niestandardowe_rozwiazania_cms: "custom_cms_solutions",
  usluga_tworzenia_oprogramowania_na_zamowienie:
    "custom_software_development_service",
  white_label_aplikacje: "white_label_apps",
  oprogramowanie_na_miare: "bespoke_software",
  wdrozenie_chmury: "cloud_adoption",
  uslugi_rozwoju_aplikacji_w_chmurze: "cloud_application_development_services",
  firmy_migracji_chmurowej: "cloud_migration_companies",
  zatrudnij_wyspecjalizowany_zespol_programistow: "dedicated_development_team",
  zespol_dedykowany_do_rozwoju_oprogramowania:
    "dedicated_software_development_team",
  integracja_i_testowanie_systemowe: "integration_and_system_testing",
  integracja_i_programowanie: "software_integration_service",
  integracje_systemow: "system_to_system_integration",
};

export const getServiceLanguage = (slug: string): string => {
  if (Object.keys(services.en).includes(slug)) {
    return "en";
  }

  if (Object.keys(services.pl).includes(slug)) {
    return "pl";
  }

  return "en";
};
